var PanningStateMachine = require("./panningStateMachine.js");
var PanningModel = require("./panningModel.js");
var lib_core = require("lib-core");
var Camera2DController = require("./../camera2D/camera2DController.js");

var PanningController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(PanningController, lib_core.Controller);

module.exports = PanningController;

PanningController.prototype.createStateMachine = function () {
    return new PanningStateMachine(this.root, this.getModel());
};

PanningController.prototype.createModel = function () {
    var editorModel = new PanningModel();
    return editorModel;
};

